/**
 * External dependencies
 */

export default class Authentication {
	constructor(cscom) {
		if (!(this instanceof Authentication)) {
			return new Authentication(cscom);
		}
		this.cscom = cscom;
	}

	jwtLogin(jwt) {
		return this.cscom.req.post(
			'/authentication/eureka-sign-in?token=' + encodeURIComponent(jwt),
			null,
			{}
		);
	}
}
